import * as React from 'react';
import { always, ifElse } from 'ramda';
import { useFormField } from '@cian/frontend-request-form-widget';

import { VALIDATION_ERROR } from './constants/phoneValidationError';
import { IPhoneFieldProps, PhoneField, validateCleanPhone } from '../../packages/PhoneField';
import { IRequestFormQuestionField } from '../../types/requestForm/requestFormField';

export const PhoneFieldContainer: React.FC<IRequestFormQuestionField> = props => {
  const validate = React.useCallback(ifElse(validateCleanPhone, always(''), always(VALIDATION_ERROR)), []);

  const {
    meta: { value, error = '', touched },
    helpers: { setValue, setTouched, setError },
  } = useFormField<string>({
    name: props.name,
    validate,
  });

  const onChange = React.useCallback<IPhoneFieldProps['onChange']>(
    ({ cleanPhone }) => {
      setValue(cleanPhone);

      if (error) {
        setError(undefined);
      }
    },
    [setValue, setError, error],
  );

  /* istanbul ignore next */
  const onBlur = React.useCallback(() => {
    setTouched(true, true);
  }, [setTouched]);

  return (
    <PhoneField
      onChange={onChange}
      placeholder={props.placeholder || '+7'}
      error={touched ? error : ''}
      initialValue={value}
      onBlur={onBlur}
    />
  );
};

PhoneFieldContainer.displayName = 'PhoneFieldContainer';
